import {
  type IntercomHistoryImport,
  IntercomHistoryImportSchema,
  type IntercomHistoryImportState,
  IntercomHistoryImportStateSchema,
  type StartIntercomHistoryImport,
} from '@sbc/domain-models/gateway';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiGet, apiSend } from './client';

const PATH = '/api/admin/intercom-history-import';
const REFRESH_MS = 10_000;
const KEY = ['admin', 'intercom-history-import'] as const;

export function useIntercomHistoryImport() {
  return useQuery<IntercomHistoryImportState>({
    queryKey: KEY,
    queryFn: () => apiGet(PATH, IntercomHistoryImportStateSchema),
    refetchInterval: REFRESH_MS,
  });
}

function useImportChange<TInput>(send: (input: TInput) => Promise<IntercomHistoryImport>) {
  const queryClient = useQueryClient();
  return useMutation<IntercomHistoryImport, Error, TInput>({
    mutationFn: send,
    onSuccess: (run) => queryClient.setQueryData<IntercomHistoryImportState>(KEY, { run }),
  });
}

export function useStartIntercomHistoryImport() {
  return useImportChange((input: StartIntercomHistoryImport) =>
    apiSend('POST', PATH, input, IntercomHistoryImportSchema),
  );
}

export function usePauseIntercomHistoryImport() {
  return useImportChange(() => apiSend('POST', `${PATH}/pause`, {}, IntercomHistoryImportSchema));
}

export function useResumeIntercomHistoryImport() {
  return useImportChange(() => apiSend('POST', `${PATH}/resume`, {}, IntercomHistoryImportSchema));
}
